import Api from '@/services/Api';

export default {
  getList() {
    return Api().get('/forms');
  },
  getListByMonthAndYear(params: any) {
    if (params && params.month && !params.year) {
      return Api().get(`/forms?month=${params.month}`);
    } if (params && !params.month && params.year) {
      return Api().get(`/forms?year=${params.year}`);
    }
    return Api().get(`/forms?month=${params.month}&year=${params.year}`);
  },
  updateStatus(params: any) {
    return Api().put(`/forms/${params.lineId}?status=${params.status}`);
  },
};
